import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";

export const PrivateRoute = ({ children, ...rest }) => {
    const { loginResponse } = useSelector(state => state.user)

    return (
        <>{loginResponse ? <Outlet /> : <Navigate to="/" />}</>
    )
}